import { render, staticRenderFns } from "./SousRubrique.vue?vue&type=template&id=ad10b24c&scoped=true"
import script from "./SousRubrique.vue?vue&type=script&lang=js"
export * from "./SousRubrique.vue?vue&type=script&lang=js"
import style0 from "./SousRubrique.vue?vue&type=style&index=0&id=ad10b24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad10b24c",
  null
  
)

export default component.exports